import { render, staticRenderFns } from "./RuleAdd.vue?vue&type=template&id=5d0f8746&scoped=true&"
import script from "./RuleAdd.vue?vue&type=script&lang=js&"
export * from "./RuleAdd.vue?vue&type=script&lang=js&"
import style0 from "./RuleAdd.vue?vue&type=style&index=0&id=5d0f8746&prod&lang=scss&"
import style1 from "./RuleAdd.vue?vue&type=style&index=1&id=5d0f8746&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0f8746",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QTime from 'quasar/src/components/time/QTime.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QStepper,QStep,QItem,QSelect,QBtn,QToggle,QInput,QDialog,QDate,QTime});qInstall(component, 'directives', {ClosePopup});
